export const isValidString = (str: string): string => {
  str = str.replace(/\s+/g, ' ')
  // allows only .’'-/ and english letters
  const regex = /^[A-Za-z.'’\-\/ ]+$/
  return regex.test(str) ? str : str.replace(/[^A-Za-z.'’\-\/ ]+/g, '')
}

export const orderCase = (str: string): string => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const isValidMail = (str: string): string => {
  return str
    .replace(/\s+/g, '')
    .trim()
    .replace(/[^a-zA-Z0-9@.]/g, '')
    .toLowerCase()
}
